import { render } from "./TopPage.vue?vue&type=template&id=5ed9c956"
import script from "./TopPage.vue?vue&type=script&lang=js"
export * from "./TopPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myDocument\\development\\Noxicel\\noxicel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__